import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { UAPPlacementTypeAlias as EPT } from '@bingads-webui-campaign-react/unified-ad-preview-library-cmui';

import { getCurrentPlacementInfo } from './util';
import { getPlacementContainerStyle } from './style';

const wrapperClassNameMap = {
  [EPT.Outlook.Web]: 'outlook-text-web',
  [EPT.Responsive.MSAN.SquareImage]: 'responsive-1x1-msan',
  [EPT.Responsive.MSAN.MSNSmallHeadline]: 'responsive-133x100-msan',
};

export const PreviewPlacementContainer = ({
  children,
  i18n,
  adType,
  placementType,
  shouldShowAdditionalDisclaimer,
}) => {
  const extraPlacementInfo = useMemo(() => getCurrentPlacementInfo(placementType) || {}, [placementType]);

  const classes = useDefaultStyles(getPlacementContainerStyle(adType));

  return (
    <div className={classes.previewPlacementContainer}>
      <div className={classnames(classes.placementWrapper, wrapperClassNameMap[placementType])}>
        {children}
      </div>
      <div className={classnames(classes.previewTypeString, 'preview-type-string')}>
        {extraPlacementInfo.previewStringKey && i18n.getString(extraPlacementInfo.previewStringKey)}
      </div>
      {
        extraPlacementInfo.showAdditionalDisclaimer && shouldShowAdditionalDisclaimer &&
        <div className={classnames(classes.additionalDisclaimer, 'addtional-disclaimer')}>
          {i18n.getString(extraPlacementInfo.disclaimerStringKey)}
        </div>
      }
    </div>
  );
};

PreviewPlacementContainer.propTypes = {
  children: PropTypes.node.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  adType: PropTypes.string,
  placementType: PropTypes.string,
  shouldShowAdditionalDisclaimer: PropTypes.bool,
};

PreviewPlacementContainer.defaultProps = {
  adType: '',
  placementType: '',
  shouldShowAdditionalDisclaimer: false,
};
